import { render, staticRenderFns } from "./lxsqForm.vue?vue&type=template&id=f204cd22&scoped=true&"
import script from "./lxsqForm.vue?vue&type=script&lang=js&"
export * from "./lxsqForm.vue?vue&type=script&lang=js&"
import style0 from "./lxsqForm.vue?vue&type=style&index=0&id=f204cd22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204cd22",
  null
  
)

export default component.exports